import { render, staticRenderFns } from "./AssetAssociationsTable.vue?vue&type=template&id=c0969a80&scoped=true&"
import script from "./AssetAssociationsTable.vue?vue&type=script&lang=js&"
export * from "./AssetAssociationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetAssociationsTable.vue?vue&type=style&index=0&id=c0969a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0969a80",
  null
  
)

export default component.exports